import { Skeleton } from 'antd'
import FormWrapperCreate from 'components/Form/FormWrapperCreate'
import styled from 'styled-components'
import {  HistoryOutlined } from '@ant-design/icons'

const WrapperComponent = styled.div`
  .box-info {
  }
`

const Component = ({ updateWieghts, title }: { updateWieghts: any; title: any; }) => {  
  return (
    <WrapperComponent>
      <FormWrapperCreate title={title} icon={<HistoryOutlined />}>
        {updateWieghts.length > 0 ? (
          <>
            <table className="table table-bordered">
              <thead>
                <tr><th style={{ textAlign: 'center' }}>Thời gian</th>
                  <th style={{ textAlign: 'center' }}>Khối lượng cũ</th>
                  <th style={{ textAlign: 'center' }}>Khối lượng quy đổi mới</th>
                  <th style={{ textAlign: 'center' }}>Khối lượng mới</th>
                  <th style={{ textAlign: 'center' }}>Gói khối lượng cập nhật mới</th>
                </tr></thead>
              <tbody>
                {updateWieghts?.map((item: any) => (

                  <tr className="text-center" key={item.id}>
                    <td>{item?.created_at}</td>
                    <td>{item.weight_from}</td>
                    <td>{item.conversion_weight}</td>
                    <td>{item.weight_to}</td>
                    <td>{item.weight_to}kg ({item.fee_to_format})</td>
                  </tr>
                ))}

              </tbody>
            </table>
          </>
        ) : (
          <div style={{ marginTop: 10 }}>
            <Skeleton active />
          </div>
        )}
      </FormWrapperCreate>
    </WrapperComponent>
  )
}

export default Component
